/**
 * File Source Selector Component
 * Allows users to choose between uploading or selecting from server
 */

import styles from './FileSourceSelector.module.css'

export type FileSource = 'upload' | 'server'

interface FileSourceSelectorProps {
  fileType: 'csv' | 'dxf'
  onSourceSelect: (source: FileSource) => void
  onCancel?: () => void
}

export function FileSourceSelector({
  fileType,
  onSourceSelect,
  onCancel,
}: FileSourceSelectorProps) {
  const fileTypeLabel = fileType === 'csv' ? 'CSV' : 'DXF/CAD'
  const fileTypeDescription = fileType === 'csv'
    ? 'CSV 파일'
    : 'CAD/DXF 도면 파일'

  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.container} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>{fileTypeLabel} 불러올 위치 선택</h2>
          <p className={styles.description}>{fileTypeDescription}을 어디서 불러올지 선택하세요</p>
        </div>

        <div className={styles.options}>
          <button className={styles.option} onClick={() => onSourceSelect('upload')}>
            <svg className={styles.icon} width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
            <h3 className={styles.optionTitle}>컴퓨터에서 업로드</h3>
            <p className={styles.optionDescription}>내 기기에서 {fileTypeLabel} 파일을 업로드합니다</p>
          </button>

          <button className={styles.option} onClick={() => onSourceSelect('server')}>
            <svg className={styles.icon} width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
              <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
              <line x1="6" y1="6" x2="6.01" y2="6" />
              <line x1="6" y1="18" x2="6.01" y2="18" />
            </svg>
            <h3 className={styles.optionTitle}>서버에서 선택</h3>
            <p className={styles.optionDescription}>서버 저장소에서 {fileTypeLabel} 파일을 선택합니다</p>
          </button>
        </div>

        {onCancel && (
          <button onClick={onCancel} className={styles.cancelButton}>
            뒤로
          </button>
        )}
      </div>
    </div>
  )
}
